module.exports = __webpack_public_path__ + "media/Faded Dreams.89b0d8ed.mp3";